module.exports = "app-discount-rates table td:first-child {\n  cursor: pointer;\n  color: blue;\n}\n"